import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconCrewStyle0 = cosmosIconCss;

const CosmosIconCrew$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconCrew extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'b6aa8851cd7e634edbf7b567f4653da9e089d669', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '36325952052d51140073e7c0212efa057db8c432', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '7f68df3d658cc33ad4f530e7c0e2b30fa7a0123a', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M12.842 6.257c.358.476.498 1.097.382 1.695l-.32 2.338c-.071 1.06-.932 1.863-1.93 1.798-.996.065-1.857-.737-1.928-1.798L8.78 7.952c-.088-.618.1-1.245.507-1.695.463-.513 1.11-.757 1.778-.757.67 0 1.317.24 1.778.757Zm-.073 6.656a.419.419 0 0 1 .453 0c1.072.537 1.763 1.686 1.778 2.955v.152c0 .264-.199.477-.444.477H7.444c-.245 0-.444-.213-.444-.477v-.152c.039-1.292.77-2.443 1.876-2.955a.435.435 0 0 1 .453 0 2.994 2.994 0 0 0 3.44 0Zm5.326-4.797c.315.39.439.9.336 1.39l-.281 1.919a1.6 1.6 0 0 1-1.698 1.475 1.6 1.6 0 0 1-1.698-1.475l-.235-1.919a1.639 1.639 0 0 1 .446-1.39 2.05 2.05 0 0 1 1.565-.621c.588-.03 1.16.197 1.565.621Zm-2.375 6.19a4.44 4.44 0 0 1 .367 1.803.39.39 0 0 0 .392.388h3.13a.39.39 0 0 0 .391-.389v-.124a2.695 2.695 0 0 0-1.604-2.376.394.394 0 0 0-.4 0c-.446.295-.973.45-1.51.442-.175 0-.35-.015-.524-.046-.242-.047-.344.093-.242.303Zm-12.151-4.8c-.103-.49.02-1 .336-1.39.406-.424.977-.65 1.565-.621a2.05 2.05 0 0 1 1.565.621c.359.37.524.883.446 1.39l-.235 1.919A1.6 1.6 0 0 1 5.548 12.9a1.6 1.6 0 0 1-1.698-1.475l-.28-1.919Zm2.344 6.602a4.431 4.431 0 0 1 .367-1.801c.102-.21 0-.35-.242-.303a2.917 2.917 0 0 1-.525.046 2.667 2.667 0 0 1-1.51-.443.394.394 0 0 0-.399 0A2.695 2.695 0 0 0 2 15.985v.124a.39.39 0 0 0 .391.389h3.13a.39.39 0 0 0 .392-.389Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconCrewStyle0; }
}, [1, "cosmos-icon-crew", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-crew"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-crew":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconCrew$1);
            }
            break;
    } });
}

const CosmosIconCrew = CosmosIconCrew$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconCrew, defineCustomElement };
